<template>
    <div v-if="is_db_admin_active || (report && !!report.description)">
        <div class="uk-grid uk-grid-small uk-margin-bottom">
            <div class="uk-width-9-10">
                <p class="uk-text-italic">{{ report.description }}</p>
            </div>
            <div class="uk-width-1-10 uk-text-right">
                <base-button
                    v-if="!!is_db_admin_active"
                    flavor="link"
                    size="mini"
                    @click.prevent="start_editing"
                >
                    <open-icon glyph="pencil" />
                </base-button>
            </div>
        </div>

        <modal-dialog
            :id="`report-${report.id}-description-editor`"
            :show.sync="editing"
        >
            <template v-slot:title>
                Report Description
            </template>

            <form-text-area
                :id="`report-${report.id}-description`"
                name="description"
                v-model="report_description"
                placeholder="Report description..."
                size="medium"
                width="1-1"
                :required="false"
                class="uk-margin-top uk-margin-bottom"
            />

            <div class="uk-modal-footer uk-text-center">
                <base-button
                    size="large"
                    @click.prevent="editing=false"
                >
                    Cancel
                </base-button>
                <base-button
                    size="large"
                    color="primary"
                    @click.prevent="save"
                >
                    Save
                </base-button>
            </div>
        </modal-dialog>
    </div>
</template>

<script type="text/javascript">
import profile_utilities from "../../mixins/ProfileUtilities"
import handles_saving from "../../mixins/HandlesSaving"

import FormTextArea from "../../ui/FormTextArea"
import BaseButton from "../../ui/BaseButton"
import OpenIcon from "../../ui/OpenIcon"
import ModalDialog from "../../dialogs/ModalDialog/ModalDialog"

export default {
    mixins: [profile_utilities, handles_saving],
    components: {
        FormTextArea,
        BaseButton,
        OpenIcon,
        ModalDialog
    },
    methods: {
        start_editing () {
            this.report_description = this.report.description
            this.editing = true
        },
        save () {
            const setting_id = `report_description_${this.report.id}`
            this.$store.dispatch("RECORD_SAVE", {
                entity: "setting",
                id: 1,
                data: { [setting_id]: this.report_description }
            }).then(response => {
                this.report.description = this.report_description
                this.editing = false
            }).catch(error => {
                this.$error(error.message)
            })
        }
    },
    props: {
        report: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            editing: false,
            report_description: ""
        }
    }
}
</script>
